import { ResidentNotificationCategory } from '../../../../common/types'

export const useContractNotificationCategories = () => ({
  contractNotificationCategories: [
    ResidentNotificationCategory.contract_lifecycle,
    ResidentNotificationCategory.contract_termination_request_approval_needed,
    ResidentNotificationCategory.contract_termination_request_created,
    ResidentNotificationCategory.contract_termination_request_kenno_accepted,
    ResidentNotificationCategory.contract_termination_request_kenno_rejected,
    ResidentNotificationCategory.contract_termination_request_tenant_accepted,
    ResidentNotificationCategory.contract_termination_request_tenant_rejected,
  ],
})
